module.exports = __webpack_public_path__ + "img/profile-photo-def.e0619f47.svg";